<script setup>
import {computed, defineProps} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  }
});
const titleImg = require("@/assets/images/xm_title.png")
const slogoImg = require("@/assets/images/hbwl/sologo.png");
const type = computed(() => store.state.coupon)
const loginType = computed(() => {
  if (!type.value) return couponConf["hbwl-xmair"].login
  return couponConf[type.value]?.login
})
</script>

<template>
  <!--{{ // couponLst[0].data }}-->
  <el-card class="coupon-card">
    <el-image :src="titleImg" style="margin-bottom: 10px"/>
    <div class="coupon-info" v-for="coup in couponLst[0]?.data" :key="coup.id">
      <div class="coupon-left">
        <div class="coupon-logo">
          <el-image :src="slogoImg"/>
        </div>
        <div class="old-prices">原价{{ parseFloat(coup.pay_score) }}元</div>
      </div>
      <div class="coupon-right">
        <div class="coupon-title"><b>{{ coup.name }}</b></div>
        <div class="coupon-jingle">
          <div class="coupon-jingle-left">
            <el-text type="info">
              {{ coup.title }}
            </el-text>
            <div class="score-number">
              <el-text :type="loginType==='xm_air'?'primary':'danger'" class="price">{{
                  coup?.score_data[loginType]?.discount
                }}
              </el-text>
              {{ coup?.score_data[loginType]?.unit }}
            </div>
          </div>
          <div class="coupon-jingle-btn">
            <el-button round :type="loginType==='xm_air'?'primary':'danger'"
                       v-if="Object.keys(props.account).length < 1 || account.balance_miles >= parseFloat(coup?.score_data[loginType]?.discount)"
                       @click="router.push({name:'detail',params:{id:coup.id}})">
              立即兑换
            </el-button>
            <el-button round type="info" v-else>
              {{ coup?.score_data[loginType]?.unit }}不足
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-card>
  <div class="recharge-content">
    <div class="recharge-title">
      兑换须知
    </div>
    <ol class="recharge-content-items">
      <li>积分兑换产品不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；</li>
      <li>《河北文旅一卡通》为<el-text type="primary">实名制电子年卡</el-text>，一人一卡，仅限本人使用；</li>
      <li>本产品为卡密产品，兑换时<el-text type="primary">请填写正确的收货手机号</el-text>，因手机号填写错误造成的损失由会员本人承担；</li>
      <li>旅游年卡激活日期：截止到2025年12月31日，使用日期激活后<el-text type="primary">365天</el-text>内有效；</li>
      <li>标准卡不限户籍，不限年龄，全国人民皆可办理，儿童卡限制14周岁（含）以下人员使用；</li>
      <li>持卡用户在有效期内可全年不限次数进入一卡通所含景区
        (特殊景区除外)，全年5次免费观影，会员权益景区每月不定期开放预约，游玩前需提前1-5天通过<el-text type="primary">“全冀游”</el-text>小程序进行领码，实际入园日期及时间以景区开放日期和时间为准。每位用户每天仅限进入同一景区一次，当天出园后无法再次入园，请合理安排时间。(因临时领码或超出领码人数而导致领码失败的情况，本公司不承担任何责任)；
      </li>
      <li>
        持卡用户领码成功后，可在领码的指定日期通过专用通道进入景区，若持卡用户利用入园的漏洞倒卖门票，一经发现立即冻结，并追究法律责任；
      </li>
      <li>本卡仅包含景区门票及门票所含部分消费项目，不包含景区内其他自费项目和保险;</li>
      <li>确认绑定的手机号为常用账号，手机号姓名、身份证信息一经绑定不可更改；</li>
      <li>
        因季节性营业、森林防火封山等其他不可抗因素而导致不能正常进入景区的，景区和发行单位均不承担任何责任，开放景区以景区官网、官微及公告为准，用户领码前需注意<el-text type="primary">“全冀游”</el-text>小程序公告；
      </li>
      <li>
        本卡包含的景区/影院等权益可能会发生增减，如有效期内因自然条件、天气气象等不可抗力因素，以及景区/影院等运营调整、主体变更、特殊活动、临时闭园、合约到期、终止经营等原因，在使用有效期内，个别签约景区/影院等或将发生使用规则调整、部分或整体项目临时停用、终止合作等情况，个别景区/影院等发生上述情况不视作影响综合权益，官方平台亦将及时发布变化的更新通告，兑换前请谨慎决定；一卡通最终包含景区以<el-text type="primary">“全冀游”</el-text>小程序公示为准，如有疑问请拨打全冀游客服热线：400-876-0311；
      </li>
      <li>
        如遇产品不能正常兑换或使用，请拨打服务热线：4000-360-195。
      </li>
    </ol>
  </div>
</template>

<style scoped lang="less">
.coupon-card {
  margin: 15px;
  --el-card-border-radius: 12px;
  --el-card-padding: 5px;

  .coupon-info {
    //height: 96px;
    display: flex;
    align-items: center;
    background-image: url("@/assets/images/hbwl/coupon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-bottom: 15px;
    //padding: 5px;

    .coupon-left {
      width: 23%;
      flex-basis: 23%;
      margin-right: 15px;
      text-align: center;
      font-size: .8rem;
      color: #ffffff;
      position: relative;
      box-sizing: border-box;
      padding: 5px;

      .old-prices {
        padding: 5px 0;
        margin-top: 5px;
        border-top: 1px dashed #ffffff;
        //禁止换行
        white-space: nowrap;
        font-size: .8rem;
      }
    }

    .coupon-right {
      width: calc(77% - 15px);
      flex-basis: calc(77% - 15px);
      box-sizing: border-box;
      padding-top: 10px;
      padding-right: 10px;
      line-height: 25px;

      .coupon-title {
        font-size: .85rem;
      }

      .coupon-jingle {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .coupon-jingle-left {
          font-size: .8rem;

          .el-text {
            font-size: .8rem;
          }

          .price {
            font-size: 1.45rem;
          }
        }


      }
    }
  }
}

.recharge-content {
  margin: 15px;
  border-radius: 15px;
  overflow: hidden;

  background: #ffffff;

  .recharge-title {
    box-sizing: border-box;
    padding: 15px;
    background: #669690;
    color: #ffffff;
    font-size: 1.23rem;
    font-weight: 600;
  }

  .recharge-content-items {
    font-size: .8em;
    text-align: justify;
    padding: 15px 15px 15px 30px;
    box-sizing: border-box;
    line-height: 1.5;

    .el-text{
      font-size: .8rem;
    }
  }
}
</style>
